import { EDealType, EOfferType } from 'shared/types/features';

/**
 * Считает extra.category для CA по фильтрам dealType + offerType.
 * Для host (посуточно) dealType отсутствует → пустая строка.
 */
export function prepareCategoryCa(
  dealType: EDealType | null | undefined,
  offerType: EOfferType | null | undefined,
): string {
  if (!dealType) {
    return '';
  }

  const isSuburban = offerType === EOfferType.Suburban;

  if (dealType === EDealType.Sale) {
    return isSuburban ? 'houseSale' : 'flatSale';
  }

  return isSuburban ? 'houseRent' : 'flatRent';
}
